import { render, staticRenderFns } from "./CostUpdateDialog.vue?vue&type=template&id=2856ce20&"
import script from "./CostUpdateDialog.vue?vue&type=script&lang=js&"
export * from "./CostUpdateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports